export default __webpack_public_path__ + "static/media/2G.3488df0e.svg";